import { VueConstructor } from 'vue'
import DefaultLayout from './DefaultLayout.vue'
import PrivateLayout from './PrivateLayout.vue'

export type LayoutType = 'default' | 'private'

type LayoutMap = {
  [key in LayoutType]: VueConstructor<Vue>
}

export const layouts: LayoutMap = {
  default: DefaultLayout,
  private: PrivateLayout,
}
